<template>
    <div class="availability-calendar" v-if="hasRecords">
        <div class="cal-head show-for-medium">
            <div class="cal-cell">Mon</div>
            <div class="cal-cell">Tue</div>
            <div class="cal-cell">Wed</div>
            <div class="cal-cell">Thu</div>
            <div class="cal-cell">Fri</div>
            <div class="cal-cell sat">Sat</div>
            <div class="cal-cell sun">Sun</div>
        </div>
        <div class="cal-body">
            <div
                class="cal-cell"
                v-for="date in dates"
                :key="date.date"
                :class="dateClass(date)"
            >
                <div
                    class="cal-week-day show-for-small-only"
                    v-text="date.week_day"
                ></div>
                <div class="cal-day">
                    {{ date.month_name }}<br />
                    {{ date.day }}
                </div>
                <div class="cal-item" :class="{ taken: isTaken(date, 1) }">1</div>
                <div class="cal-item" :class="{ taken: isTaken(date, 2) }">2</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AvailabilityCalendar',
        props: {
            dates: {
                type: Array,
                default: () => []
            },
            searched: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            hasRecords() {
                return this.dates.length > 0;
            }
        },
        methods: {
            isSearched(date) {
                return this.searched.includes(date);
            },
            isTaken(date, id) {
                return date.is_taken.includes(id);
            },
            dateClass(date) {
                return [
                    {
                        searched: this.searched.includes(date.date),
                        past: date.is_past,
                    },
                    [date.day_lower]
                ]
            }
        }
    }
</script>